import React from "react";
import { useGARouteTracker } from "../hooks/useGARouteTracker";

const RouteTracker = () => {
  useGARouteTracker();
  return <></>;
};

export default RouteTracker;
